import { createContext, ReactNode, useState } from "react";
import { Picking } from "interfaces/picking";

interface SelectPickingContext {
  selectedPickings: Picking[];
  addPickings: (Pickings: Picking[]) => void;
  removePicking: (pickingId: number) => void;
  reset: () => void;
  movePicking: (id: number, direction: "up" | "down") => void;
}

export const SelectedPickingContext = createContext({} as SelectPickingContext);

interface SelectedPickingContextProviderProps {
  children: ReactNode;
}

const SelectedPickingContextProvider = ({
  children,
}: SelectedPickingContextProviderProps) => {
  const [selectedPickings, setSelectedPickings] = useState<Picking[]>([]);

  function addPickings(Pickings: Picking[]) {
    setSelectedPickings(Pickings);
  }

  function removePicking(pickingId: number) {
    setSelectedPickings((prev) =>
      prev.filter((picking) => picking.id !== pickingId)
    );
  }

  function reset() {
    setSelectedPickings([]);
  }

  function movePicking(id: number, direction: "up" | "down") {
    setSelectedPickings((prev) => {
      const index = prev.findIndex((p) => p.id === id);
      if (index === -1) return prev; // não encontrado

      const newPickings = [...prev];

      if (direction === "up" && index > 0) {
        // troca com o anterior
        [newPickings[index - 1], newPickings[index]] = [
          newPickings[index],
          newPickings[index - 1],
        ];
      } else if (direction === "down" && index < newPickings.length - 1) {
        // troca com o próximo
        [newPickings[index + 1], newPickings[index]] = [
          newPickings[index],
          newPickings[index + 1],
        ];
      }

      return newPickings;
    });
  }

  return (
    <SelectedPickingContext.Provider
      value={{
        addPickings,
        removePicking,
        selectedPickings,
        reset,
        movePicking,
      }}
    >
      {children}
    </SelectedPickingContext.Provider>
  );
};

export { SelectedPickingContextProvider };
